import {
  Country,
  ICountry,
  IRole,
  IUser,
  IUserClient,
  IUserData,
  IUserDetail,
  IUserDetailData,
  Role,
  UserClient,
} from "@/entities";

export class User implements IUser {
  readonly id?: number;
  readonly oid?: string;
  readonly username?: string;
  readonly name?: string;
  readonly lastName?: string;
  readonly email?: string;
  readonly createdAt?: Date | string;
  readonly updatedAt?: Date | string;
  readonly active?: boolean;
  readonly admin?: boolean;
  readonly supervisor?: boolean;
  readonly approver?: boolean;
  readonly country?: ICountry;
  readonly roles?: IRole[];
  readonly userType?: string;
  readonly solCreated?: boolean;
  readonly solSynchronized?: boolean;
  readonly disclaimerAccepted?: boolean;
  readonly servicesPointOnCashUser?: number;
  readonly approvalFlowNotificationsEnabled?: boolean;

  constructor(data: IUserData) {
    this.id = data.id;
    this.oid = data.oid;
    this.username = data.username;
    this.name = data.name;
    this.lastName = data.lastName;
    this.email = data.email;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.active = data.active;
    this.admin = data.admin;
    this.supervisor = data.supervisor;
    this.approver = data.approver;
    this.userType = data.userType;
    this.solCreated = data.solCreated;
    this.solSynchronized = data.solSynchronized;
    this.disclaimerAccepted = data.disclaimerAccepted;
    this.servicesPointOnCashUser = data.servicesPointOnCashUser;
    this.approvalFlowNotificationsEnabled = data.approvalFlowNotificationsEnabled;

    if (data.country) {
      this.country = new Country(data.country);
    }

    this.roles = data.roles?.map((role) => new Role(role));
  }
}

export class UserDetail extends User implements IUserDetail {
  readonly country?: ICountry;
  readonly roles?: IRole[];
  readonly clients?: IUserClient[];
  readonly approvals?: IUserClient[];

  constructor(data: IUserDetailData) {
    super(data);

    if (data.country) {
      this.country = new Country(data.country);
    }

    this.roles = data.roles?.map((role) => new Role(role));
    this.clients = data.clients?.map((client) => new UserClient(client));
    this.approvals = data.approvals?.map((approval) => new UserClient(approval));
  }
}
